
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurzy/[slug]",
      function () {
        return require("private-next-pages/kurzy/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kurzy/[slug]"])
      });
    }
  